function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Simple deep-copy function for cloning objects.
 */
var deepCopy = function deepCopy(obj) {
  if (_typeof(obj) !== 'object' || obj === null) {
    return obj;
  }

  return Object.keys(obj).reduce(function (acc, key) {
    var value = obj[key];
    acc[key] = deepCopy(value);
    return acc;
  }, Array.isArray(obj) ? [] : {});
};

export default deepCopy;